var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.889 5.88-2.593-2.593A1.834 1.834 0 0 0 13 2.75H6.426c-1.013 0-1.833.82-1.833 1.833v12.834c0 1.013.82 1.833 1.833 1.833h9.167c1.013 0 1.833-.82 1.833-1.833V7.176c0-.486-.193-.953-.537-1.296h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.426 7.333h-3.667a.917.917 0 0 1-.916-.916V2.75M7.343 10.083h5.5M7.343 12.833h5.5M7.343 15.583h3.969"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.01 0h22v22h-22z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticle);
export default __webpack_public_path__ + "static/media/iconArticle.5a4b9f7ec2c462157814a900d57b5bbf.svg";
export { ForwardRef as ReactComponent };